import React, {useState, useEffect, useCallback} from 'react'
import './../../App.css';
import './Reports.css';
import axios from 'axios';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import { format } from 'date-fns';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
//icons
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function TimeKeepingReport({user, isHideSideMenu}) {
    const [payrollPeriod, setPayrollPeriod] = useState("");
    const [companyId, setCompanyId] = useState(0);
    const [company, setCompany] = useState(null);
    const [classification, setClassification] = useState(null);
    const [departmentId, setDepartmentId] = useState(0);
    const [locationId, setLocationId] = useState(0);
    const [errorState, setErrorState] = useState(false);
    const [loading, setLoading] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    /* const report = useCallback(async (_data) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        const dateHeaders = [];

        const start = new Date(payrollPeriod.dateFrom);
        const end = new Date(payrollPeriod.dateTo);

        const dateMap = [];

        const current = new Date(start);
        current.setHours(0, 0, 0, 0); // IMPORTANT

        const last = new Date(end);
        last.setHours(0, 0, 0, 0); // IMPORTANT

        while (current <= last) {
            const key = current.getFullYear().toString() +
                        String(current.getMonth() + 1).padStart(2, '0') +
                        String(current.getDate()).padStart(2, '0');

            const header = current.getDate().toString();

            dateMap.push({ header, key });

            current.setDate(current.getDate() + 1);
        }

        const header = [
            'NAME',
            'RH',
            ...dateHeaders,
            'TOTAL HOURS',
            'TOTAL ND',
            'OT',
            'ABS',
            'LATE',
        ];

        const headerRow = worksheet.addRow(header);
        const columns = [
            { header: 'NAME', key: 'employeePersonalInformationFullName', width: 30 },
            { header: 'RH', key: 'rh', width: 10 },
        ];

        dateMap.forEach(d => {
            columns.push({
                header: d.header,
                key: d.key,
                width: 12,
            });
        });

        columns.push(
            { header: 'TOTAL HOURS', key: 'totalHoursWorked', width: 12 },
            { header: 'TOTAL ND', key: 'nd', width: 12 },
            { header: 'OT', key: 'ot', width: 10 },
            { header: 'ABS', key: 'abs', width: 10 },
            { header: 'LATE', key: 'late', width: 15 }
        );

        worksheet.columns = columns;
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _data.forEach(item => {
            const row = {
                employeePersonalInformationFullName: item.employeePersonalInformationFullName,
                rh: "8.00", // ✅ FIX HERE
                totalHoursWorked: item.totalHoursWorked,
                nd: item.nd,
                ot: item.ot,
                abs: item.abs,
                late: item.late,
            };

            item.dailyRecords?.forEach(d => {
                const key = d.dateKey; // yyyyMMdd from backend
                row[key] = d.hoursWorked;
            });

            worksheet.addRow(row);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'ProcessedDetailed.xlsx');
    }, [payrollPeriod.dateFrom, payrollPeriod.dateTo]); */

    const report = useCallback(async (_data) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Time Keeping Report', {
            views: [{ showGridLines: false }] // Clean look like the image
        });

        // 1. GENERATE DATE RANGE
        const start = new Date(payrollPeriod.dateFrom);
        const end = new Date(payrollPeriod.dateTo);
        const dateMap = [];
        let current = new Date(start);
        while (current <= end) {
            dateMap.push({
                dayNum: current.getDate(),
                dayName: current.toLocaleDateString('en-US', { weekday: 'short' }),
                key: current.getFullYear().toString() +
                    String(current.getMonth() + 1).padStart(2, '0') +
                    String(current.getDate()).padStart(2, '0')
            });
            current.setDate(current.getDate() + 1);
        }

        // 2. DEFINE TOP HEADERS (Title & Period)
        console.log({classification})
        worksheet.getCell('A1').value = `${classification?.description ?? ""}`;
        worksheet.getCell('A1').font = { bold: true, size: 14 };
        
        const periodString = `PAYROLL PERIOD: ${start.toLocaleDateString('en-US', { month: 'short', day: '2-digit' }).toUpperCase()} - ${end.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).toUpperCase()}`;
        worksheet.getCell('A2').value = periodString;
        worksheet.getCell('A2').font = { bold: true, size: 11, color: { argb: 'FFFF0000' } };

        // 3. DEFINE THE TWO-ROW TABLE HEADER (Rows 4 & 5)
        // Row 4: Date numbers
        const headerRow1 = ['', 'NAME', 'RH'];
        dateMap.forEach(d => headerRow1.push(d.dayNum));
        headerRow1.push('TOTAL', 'TOTAL', 'O.T.', 'ABS', 'LATE');
        
        // Row 5: Day names & secondary labels
        const headerRow2 = ['', '', '']; // Spacers for Name/RH
        dateMap.forEach(d => headerRow2.push(d.dayName));
        headerRow2.push('HOURS', 'ND', '', '', '');

        worksheet.getRow(4).values = headerRow1;
        worksheet.getRow(5).values = headerRow2;

        // 4. COLUMN CONFIGURATION
        const columns = [
            { key: 'index', width: 4 },
            { key: 'name', width: 35 },
            { key: 'rh', width: 6 },
            ...dateMap.map(d => ({ key: d.key, width: 6 })),
            { key: 'totalHours', width: 10 },
            { key: 'totalNd', width: 10 },
            { key: 'ot', width: 8 },
            { key: 'abs', width: 8 },
            { key: 'late', width: 10 },
        ];
        worksheet.columns = columns;

        // 5. ADD THE "DIRECT - MONTHLY" BLUE SUB-HEADER
        const subHeaderRow = worksheet.addRow({ name: '' });
        const rowNum = subHeaderRow.number;
        worksheet.mergeCells(`B${rowNum}:I${rowNum}`); // Merge over several columns
        subHeaderRow.eachCell((cell) => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '9CC2E5' } }; // Light Blue
            cell.font = { bold: true, italic: true };
        });

        // 6. POPULATE DATA
        _data.forEach((item, index) => {
            const rowData = {
                index: index + 1,
                name: item.employeePersonalInformationFullName.toUpperCase(),
                rh: 8,
                totalHours: item.totalHoursWorked,
                totalNd: item.nd || "0.00",
                ot: item.ot || 0,
                abs: item.abs || 0,
                late: item.late || 0
            };

            // Map daily hours/status
            item.dailyRecords?.forEach(d => {
                rowData[d.dateKey] = d.status || d.hoursWorked; // Status could be 'OFFSET', 'OFF', etc.
            });

            const newRow = worksheet.addRow(rowData);

            // Styling each data cell
            newRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                // Default alignment and borders
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                cell.border = {
                    top: { style: 'thin', color: { argb: 'FFD3D3D3' } },
                    left: { style: 'thin', color: { argb: 'FFD3D3D3' } },
                    bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } },
                    right: { style: 'thin', color: { argb: 'FFD3D3D3' } }
                };

                // Conditional Coloring based on image
                const val = cell.value?.toString().toUpperCase();
                if (val === 'OFFSET') {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F8CBAD' } }; // Peach/Orange
                } else if (val === 'FB' || val === 'XYLO' || val === 'VL') {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE699' } }; // Yellowish
                } else if (val === 'EL') {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'C6E0B4' } }; // Light Green
                } else if (val === 'OFF') {
                    cell.font = { color: { argb: 'FFA9A9A9' } }; // Gray text
                }

                // Bold the Name column
                if (colNumber === 2) cell.alignment = { horizontal: 'left' };
            });
        });

        // 7. FINAL HEADER STYLING (The Blue headers from the image)
        [4, 5].forEach(rNum => {
            const row = worksheet.getRow(rNum);
            row.eachCell((cell) => {
                cell.font = { bold: true, color: { argb: 'FF0070C0' }, size: 9 };
                cell.alignment = { horizontal: 'center' };
                cell.border = { bottom: { style: 'thin' } };
            });
        });

        // Merge labels for columns A, B, C across headers
        worksheet.mergeCells('B4:B5'); // NAME
        worksheet.mergeCells('C4:C5'); // RH

        // 8. EXPORT
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Time_Keeping_Report_${new Date().getTime()}.xlsx`);

    }, [payrollPeriod.dateFrom, payrollPeriod.dateTo, classification]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Reports/time-keeping-report`;

        const data = {
            ...user,
            employeePersonalInformationId: 0,
            dateFrom: payrollPeriod.dateFrom,
            dateTo: payrollPeriod.dateTo,
            classificationId: classification ? classification?.id : 0,
            locationId: locationId
        };

        try {
            setLoading(true);
            const response = await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            console.log("RES", response.data)
            report(response.data);
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoading(false);
        }
    }, [user, report, payrollPeriod, classification, locationId]);

    const generate = () =>{
        if(!payrollPeriod
            || !company
            || !classification
        ){
            setErrorState(true);
            return;
        }
        setErrorState(false);
        fetchData();
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Time Keeping Report"}</span>
                            </div>
                            <h3>Generate Time Keeping Report</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row" style={{alignItems: "center", justifyContent: "normal"}}>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Payroll Period</div>
                                    <div className="info-item-input">
                                        <PayrollPeriodIdSelect data={payrollPeriod} setData={setPayrollPeriod} isEditable={true}/>
                                    </div>
                                    <span style={{
                                                visibility: !payrollPeriod && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Company</div>
                                    <div className="info-item-input">
                                        <CompanyTypeSelect companyId={companyId} setCompanyId={setCompanyId} setCompany={setCompany}/>
                                    </div>
                                    <span style={{
                                                visibility: !companyId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Classification</div>
                                    <div className="info-item-input">
                                        <ClassificationIdSelect data={classification} setData={setClassification} isEditable={true}/>
                                    </div>
                                    <span style={{
                                                visibility: !classification && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="info-item-holder row" style={{justifyContent: "normal"}}>
                                <div className="info-item3 info-item column hidden">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Department</div>
                                    <div className="info-item-input">
                                        <DepartmentIdSelect departmentId={departmentId} setDepartmentId={setDepartmentId}/>
                                    </div>
                                    <span style={{
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Location</div>
                                    <div className="info-item-input">
                                        <LocationIdSelect locationId={locationId} setLocationId={setLocationId}/>
                                    </div>
                                    <span style={{
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row">
                                <button id="activeEmployeesGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

/* function PayrollPeriodIdSelect({data, setData}){
    const [isSelected, setIsSelected] = useState(false);
    
    const [payrollPeriodIds, setPayrollPeriodIds] = useState([]);

    const fetchData = async () => {
        //const currentYear = new Date().getFullYear();
        //const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
        const apiUrl =  domain + `/api/PayrollPeriod/active`; // changed

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setPayrollPeriodIds(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    function textFormatDate(dateStr) {
        const date = new Date(dateStr);
        const options = { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        };
        const formattedDate = date.toLocaleDateString("en-US", options);
        return formattedDate;
    }

    useEffect(() => {
        fetchData();
        if(payrollPeriodId !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payrollPeriodId]);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayrollPeriodId(event.target.value);
        const payrollPeriodSelected = payrollPeriodIds.find(payrollPeriod => payrollPeriod.id === parseInt(event.target.value));
        setPayrollPeriodDescription(`${textFormatDate(payrollPeriodSelected.dateFrom)} to ${textFormatDate(payrollPeriodSelected.dateTo)}`)
    };

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payrollPeriodId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose payroll period</option>
            {payrollPeriodIds.map((payrollPeriodId) => ( 
                SetPayrollPeriodId(payrollPeriodId)
            ))}
            </select>
        </div>
    );
};
function SetPayrollPeriodId(payrollPeriodId){
    const formattedDateFrom = format(payrollPeriodId.dateFrom, 'MM/dd/yyyy');
    const formattedDateTo = format(payrollPeriodId.dateTo, 'MM/dd/yyyy');

    return(
        <option value={payrollPeriodId.id}>{`${formattedDateFrom} - ${formattedDateTo} ${payrollPeriodId.payTypeDescription ? payrollPeriodId.payTypeDescription : ""}`}
        </option>
    )
} */

const PayrollPeriodIdSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/PayrollPeriod/active`;
        try {
            const response = await axios.get(apiUrl, {
            headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    return (
        <div className="flex flex-col gap-1">
            <div>
                <select
                    id="employee-select-PagibigReport"
                    value={data?.id || ""}
                    onChange={handleSelectChange}
                    disabled={!isEditable}
                    style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}
                >
                    <option value=""> Choose period </option>
                    {_data.map((item) => (
                    <option key={item.id} value={item.id} className='text-gray-700'>
                        {`${format(item.dateFrom, 'MM/dd/yyyy')} - ${format(item.dateTo, 'MM/dd/yyyy')} (${item.payTypeDescription})`}
                    </option>
                    ))}
                </select>
            </div>
        </div>
    );
};
const ClassificationIdSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Classification/active`;
        try {
            const response = await axios.get(apiUrl, {
            headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    return (
        <div className="flex flex-col gap-1">
            <div>
                <select
                    id="employee-select-PagibigReport"
                    value={data?.id || ""}
                    onChange={handleSelectChange}
                    disabled={!isEditable}
                    style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}
                >
                    <option value=""> Choose classification </option>
                    {_data.map((item) => (
                    <option key={item.id} value={item.id} className='text-gray-700'>
                        {item.description}
                    </option>
                    ))}
                </select>
            </div>
        </div>
    );
};
function CompanyTypeSelect({companyId, setCompanyId, setCompany}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const selectedCompanyId = event.target.value; // Get the selected company ID
        setCompanyId(selectedCompanyId);
        const selectedCompany = data.find((comp) => comp.id.toString() === selectedCompanyId.toString()); // Find the full company object

        if (selectedCompany) {
            setCompany(selectedCompany); // Set the full company object
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Company/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if (companyId !== "" && companyId !== 0 && companyId !== null && companyId !== undefined && companyId?.length !== 0) {
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [companyId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={companyId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose company type</option>
            {data.map((companyId) => ( 
                SetCompanyType(companyId)
            ))}
            </select>
        </div>
    );
};
function SetCompanyType(company){
    return(
        <option value={company.id}>{
            company.name}
        </option>
    )

}
/* function ClassificationIdSelect({classificationId, setClassificationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose classification</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
            </select>
        </div>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
} */
function DepartmentIdSelect({departmentId, setDepartmentId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setDepartmentId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Department/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(departmentId !== "" && departmentId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [departmentId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={departmentId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose department</option>
            {data.map((departmentId) => ( 
                SetDepartmentId(departmentId)
            ))}
            </select>
        </div>
    );
};
function SetDepartmentId(departmentId){
    return(
        <option value={departmentId.id}>{
            departmentId.description}
        </option>
    )
}
function LocationIdSelect({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose location</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
export default TimeKeepingReport
